import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form } from "react-bootstrap";
import styles from "page.module.css";

const ResultTableSingleKeyWords = ({ data }) => {
  const itemsPerPage = 5; // Number of items per page
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedKeyword, setSelectedKeyword] = useState("domain");
  const [domainData, setDomainData] = useState([]);
  const [pageData, setPageData] = useState([]);

  useEffect(() => {
    if (data && Array.isArray(data) && data.length > 0) {
      setDomainData(data);
      const result = [];

      data.forEach((item) => {
        const { rank, internal_pages } = item;

        Object.values(internal_pages).forEach((pages) => {
          pages.forEach(([subRank, url]) => {
            result.push({ url, rank: subRank });
          });
        });
      });
      result.sort((a, b) => a.rank - b.rank);
      setPageData(result);
    }
  }, [data]);

  // Safety check for undefined or null data
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div className="text-center p-4">
        <p className="text-muted">No data available to display.</p>
      </div>
    );
  }

  // Pagination logic
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = data.slice(startIndex, startIndex + itemsPerPage);

  const handleShowModal = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedItem(null);
  };

  const handleKeywordChange = (event) => {
    setSelectedKeyword(event.target.value);
  };

  return (
    <>
      <div className="row">
        <div className="col-8">
          <Form.Group className="mb-3">
            <Form.Label>Filter by Keyword</Form.Label>
            <Form.Select value={selectedKeyword} onChange={handleKeywordChange}>
              <option value="domain">Domain Level</option>
              <option value="page">Page Level</option>
            </Form.Select>
          </Form.Group>
        </div>
      </div>
      <div>
        {selectedKeyword === "domain" && (
          <div className={styles.table_container}>
            <Table hover className="table-responsive">
              <thead>
                <tr>
                  <th
                    className={`text-center p-1 text-nowrap ${styles.bg_custom_4}`}
                    style={{
                      backgroundColor: "white",
                      borderRight: "2px solid white",
                    }}
                  >
                    Domain
                  </th>
                  <th
                    className={`text-center p-1 text-nowrap ${styles.bg_custom_4}`}
                    style={{
                      backgroundColor: "white",
                      borderRight: "2px solid white",
                    }}
                  >
                    Keyword Rank
                  </th>
                  <th
                    className={`text-center p-1 text-nowrap ${styles.bg_custom_4}`}
                    style={{
                      backgroundColor: "white",
                      borderRight: "2px solid white",
                    }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {domainData.map((item, index) => (
                  <tr key={index}>
                    <td style={{ wordWrap: "break-word", maxWidth: "200px" }}>
                      {item.domain}
                    </td>
                    <td className="text-center align-middle">{item.rank}</td>
                    <td className="text-center align-middle">
                      <Button onClick={() => handleShowModal(item)}>
                        View More
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
        {selectedKeyword === "page" && (
          <div className={styles.table_container}>
            <div className="table-responsive">
              <Table hover>
                <thead>
                  <tr>
                    <th
                      className={`text-center p-1 text-nowrap ${styles.bg_custom_4}`}
                      style={{
                        backgroundColor: "white",
                        borderRight: "2px solid white",
                      }}
                    >
                      Page
                    </th>
                    <th
                      className={`text-center p-1 text-nowrap ${styles.bg_custom_4}`}
                      style={{
                        backgroundColor: "white",
                        borderRight: "2px solid white",
                      }}
                    >
                      Rank
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {pageData.map((item, index) => (
                    <tr key={index}>
                      <td style={{ wordWrap: "break-word", maxWidth: "200px" }}>
                        {item.url}
                      </td>
                      <td className="text-center align-middle">{item.rank}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        )}
      </div>

      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Details for {selectedItem?.domain}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem &&
            Object.entries(selectedItem.internal_pages).map(
              ([category, pages], i) => {
                return (
                  <div key={i}>
                    <h5>{category}</h5>
                    <Table hover>
                      <thead>
                        <tr>
                          <th
                            className={`text-center p-1 text-nowrap ${styles.bg_custom_4}`}
                            style={{
                              backgroundColor: "white",
                              borderRight: "2px solid white",
                            }}
                          >
                            Page
                          </th>
                          <th
                            className={`text-center p-1 text-nowrap ${styles.bg_custom_4}`}
                            style={{
                              backgroundColor: "white",
                              borderRight: "2px solid white",
                            }}
                          >
                            Rank
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {pages.map((pageItem, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                wordWrap: "break-word",
                                maxWidth: "200px",
                              }}
                            >
                              {pageItem[1]}
                            </td>
                            <td className="text-center align-middle">
                              {pageItem[0]}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                );
              }
            )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ResultTableSingleKeyWords;
